/**
 * SeedAvatar — deterministic gradient avatar from a name/seed.
 * No external CDN — pure CSS gradient + initials.
 */
export function SeedAvatar({ seed = "", size = 40, className = "" }) {
  const s = String(seed || "?");
  // Simple hash → hue
  let hash = 0;
  for (let i = 0; i < s.length; i++) hash = (hash << 5) - hash + s.charCodeAt(i);
  const hue = Math.abs(hash) % 360;
  const bg = `linear-gradient(135deg, hsl(${hue}deg 65% 55%) 0%, hsl(${(hue + 55) % 360}deg 65% 45%) 100%)`;
  const initials = s
    .replace(/[^A-Za-z0-9]/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase() || "?";
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-bold text-white shadow-sm ring-1 ring-black/5 ${className}`}
      style={{
        width: size,
        height: size,
        background: bg,
        fontSize: Math.round(size * 0.4),
      }}
    >
      {initials}
    </span>
  );
}

const TIER_COLORS = {
  bronze: "border-amber-700/40 bg-amber-50 text-amber-800",
  silver: "border-neutral-400/50 bg-neutral-100 text-neutral-800",
  gold: "border-amber-400 bg-amber-100 text-amber-900",
  platinum: "border-amber-400 bg-amber-100 text-amber-900",
};

export function BadgeChip({ badge, size = "sm", showName = false }) {
  const tier = badge?.tier || "bronze";
  const dim = size === "lg" ? "h-10 w-10 text-xl" : size === "md" ? "h-8 w-8 text-base" : "h-6 w-6 text-sm";
  return (
    <span
      title={`${badge?.name || ""} — ${tier}`}
      className={`inline-flex items-center gap-1 ${TIER_COLORS[tier]} ${showName ? "rounded-full border px-2 py-0.5" : ""}`}
    >
      <span className={`inline-flex items-center justify-center rounded-full border ${dim} ${TIER_COLORS[tier]}`}>
        {badge?.icon || "🏅"}
      </span>
      {showName && <span className="text-[10px] font-semibold uppercase tracking-wide">{badge?.name}</span>}
    </span>
  );
}
